module.exports = __webpack_public_path__ + "img/improve_section_left_bottom.5bae37b4.png";